/* eslint-disable no-restricted-syntax */
/* eslint-disable no-plusplus */
/* eslint-disable guard-for-in */
/* eslint-disable no-use-before-define */
export function buildQueryString(object: any) {
  if (Object.prototype.toString.call(object) !== "[object Object]") return "";

  const args: any[] = [];

  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const key in object) {
    destructure(key, object[key]);
  }

  function destructure(key: string, value: any) {
    if (Array.isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        destructure(`${key}[${i}]`, value[i]);
      }
    } else if (Object.prototype.toString.call(value) === "[object Object]") {
      for (const i in value) {
        destructure(`${key}[${i}]`, value[i]);
      }
    } else if (value != null && value !== "") {
      args.push(`${key}=${encodeURIComponent(value)}`);
    }
  }

  return args.join("&");
}
